import React from "react";

const ParrotText: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={`text-center text-[var(--color-orange)] text-4xl font-extrabold font-[Poppins] break-words ${className}`}>
        parrot
    </div>
  );
};

export default ParrotText;